import { GrossProfitLabelTextHelper } from '../labelTextHelper/GrossProfitLabelTextHelper';
import { HeaderItem } from '../../model/HeaderItem';

const excludedImportFieldList = ['dateCreateAt', 'dateModifyAt'];

export const GrossProfitHeaderHelper = {
    getHeaderItems(): HeaderItem[] {
        return [
            {
                text: GrossProfitLabelTextHelper.getLabelText.dateOrderOn,
                value: 'dateOrderOn',
                format: 'date'
            },
            { text: GrossProfitLabelTextHelper.getLabelText.orderNumber, value: 'orderNumber' },
            { text: GrossProfitLabelTextHelper.getLabelText.marketplaceCode, value: 'marketplaceCode' },
            { text: GrossProfitLabelTextHelper.getLabelText.orderAmountBaseCurrency, value: 'orderAmountBaseCurrency' },
            { text: GrossProfitLabelTextHelper.getLabelText.commissionPercentage, value: 'commissionPercentage' },
            {
                text: GrossProfitLabelTextHelper.getLabelText.commissionAmountBaseCurrency,
                value: 'commissionAmountBaseCurrency'
            },
            {
                text: GrossProfitLabelTextHelper.getLabelText.transactionFeeBaseCurrency,
                value: 'transactionFeeBaseCurrency'
            },
            {
                text: GrossProfitLabelTextHelper.getLabelText.productCostAmountTotalBaseCurrency,
                value: 'productCostAmountTotalBaseCurrency'
            },
            {
                text: GrossProfitLabelTextHelper.getLabelText.orderItemPriceAmountTotalBaseCurrency,
                value: 'orderItemPriceAmountTotalBaseCurrency'
            },
            {
                text: GrossProfitLabelTextHelper.getLabelText.shippingFeeAmountBaseCurrency,
                value: 'shippingFeeAmountBaseCurrency'
            },
            {
                text: GrossProfitLabelTextHelper.getLabelText.grossProfitAmountBaseCurrency,
                value: 'grossProfitAmountBaseCurrency'
            },
            { text: GrossProfitLabelTextHelper.getLabelText.baseCurrencyCode, value: 'baseCurrencyCode' },
            { text: GrossProfitLabelTextHelper.getLabelText.foreignCurrencyCode, value: 'foreignCurrencyCode' },
            {
                text: GrossProfitLabelTextHelper.getLabelText.exchangeRateBaseCurrencyToForeignCurrency,
                value: 'exchangeRateBaseCurrencyToForeignCurrency'
            },
            {
                text: GrossProfitLabelTextHelper.getLabelText.exchangeRateForeignCurrencyToBaseCurrency,
                value: 'exchangeRateForeignCurrencyToBaseCurrency'
            },
            {
                text: GrossProfitLabelTextHelper.getLabelText.dateCalculationAt,
                value: 'dateCalculationAt',
                format: 'datetime'
            },
            {
                text: GrossProfitLabelTextHelper.getLabelText.dateCreateAt,
                value: 'dateCreateAt',
                format: 'datetime'
            },
            {
                text: GrossProfitLabelTextHelper.getLabelText.dateModifyAt,
                value: 'dateModifyAt',
                format: 'datetime'
            },
            { text: GrossProfitLabelTextHelper.getLabelText.orderItemSkuList, value: 'orderItemSkuList' }
        ];
    },

    getDateTimePropertyList(): string[] {
        return this.getHeaderItems()
            .filter((item) => item.format === 'datetime')
            .map((item) => item.value);
    },

    getDatePropertyList(): string[] {
        return this.getHeaderItems()
            .filter((item) => item.format === 'date')
            .map((item) => item.value);
    },

    getActionHeaderItem(): HeaderItem {
        return { text: GrossProfitLabelTextHelper.getLabelText.action, value: 'action' };
    },

    getCsvHeader() {
        return [...this.getHeaderItems().map((item) => ({ key: item.value, text: item.text }))];
    },

    getHeaders() {
        return [...this.getHeaderItems(), this.getActionHeaderItem()];
    },

    getImportFields() {
        return this.getFilteredHeaderItems().reduce((acc, item) => {
            acc[item.value] = {
                required: false,
                label: item.text
            };
            return acc;
        }, {} as Record<string, { required: boolean; label: string }>);
    },

    getImportHeaders() {
        return this.getFilteredHeaderItems();
    },

    getFilteredHeaderItems() {
        return this.getHeaderItems().filter((header) => !excludedImportFieldList.includes(header.value));
    }
};
